import { useLoaderData } from 'react-router';

import { DetailBreadcrumbBar } from '~/ui-rocco/pages/detail-shared';
import type { loader } from '~/routes/_app.project.$urlSegment._index';
import { PagesEnum } from '~/utils/route-config';

/**
 * The phone's category trail, leading the credits row — the product page's
 * pattern. The hero keeps its own bar on desktop; down here the trail is
 * pure wayfinding, filed with the tags it sits above, and carries no
 * figures — the practice's views and saves live in the trust row beside
 * the CTAs, under the name they describe.
 */
export const ProjectBreadcrumbBar = () => {
    const { project } = useLoaderData<typeof loader>();
    const category = project.Categories?.[0];

    return (
        <DetailBreadcrumbBar
            theme="dark"
            className="max-md:pb-4 md:hidden"
            trail={[
                { label: 'Home', to: '/' },
                { label: 'Projects', to: PagesEnum.PROJECTS },
                ...(category?.PrettyTitle && category.Link
                    ? [{ label: category.PrettyTitle, to: category.Link }]
                    : []),
            ]}
        />
    );
};
